import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import CentralDaMarcaBffService from '@/services/central-da-marca-bff.service'
import type { PageDTO } from '@/data/dto/page.dto'
import type { PageStoreContract } from '@/data/store/page.store.contract'

type BasicState<T> = {
  loading: boolean
  data: T | null
  error: string | null
}

type LocalState = BasicState<PageDTO>

@Module({
  name: 'PersonalityPageStore',
  dynamic: true,
  namespaced: true,
  store
})
export class PersonalityPageStore extends VuexModule implements PageStoreContract {
  bffService = new CentralDaMarcaBffService()

  paginationLimit = 10

  _state: LocalState = {
    loading: false,
    error: null,
    data: null
  }

  get isLoading(): boolean {
    return this._state.loading
  }

  get all(): PageDTO | null {
    return this._state.data
  }

  @Mutation
  updatePersonalityPageState(payload: Partial<LocalState>): void {
    this._state = {
      ...this._state,
      ...payload
    }
  }

  @Action
  async getDataPage(): Promise<void> {
    this.updatePersonalityPageState({
      loading: true,
      error: null
    })

    try {
      const response = await this.bffService.getPersonalityPageByTitle()
      this.updatePersonalityPageState({ data: response })
    } catch (error: any) {
      this.updatePersonalityPageState({
        error: error?.message
      })
    } finally {
      this.updatePersonalityPageState({
        loading: false
      })
    }
  }
}
